import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListEmptyContainer = styled.div<React.CSSProperties>`
  color: ${Colors.text};
  font-family: ${Fonts['regular']};
  font-size: ${54 * Screen.widthRatio}px;
  position: fixed;
  top: ${510 * Screen.widthRatio}px;
  left: ${1092 * Screen.widthRatio}px;
`;

export default ChannelListEmptyContainer;
